var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCheckmarkFillLight = function SvgCheckmarkFillLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#E8F8F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.496 8.89-5.137 5.137-1.875-1.894c-.097-.078-.254-.078-.332 0l-.566.566c-.078.078-.078.235 0 .332l2.617 2.598a.225.225 0 0 0 .332 0l5.86-5.86c.078-.078.078-.234 0-.332l-.567-.546c-.078-.098-.234-.098-.332 0Z",
    fill: "#20CA8D"
  })));
};

export default SvgCheckmarkFillLight;